import { defineComponent as a, h as r } from "vue";
import n from "./highrise1074.mjs";
import t from "./highrise1143.mjs";
import f from "./highrise1104.mjs";
import { resolveSlot as s } from "./highrise1059.mjs";
import i from "./highrise1624.mjs";
const x = a({
  name: "InternalSelectionSuffix",
  props: {
    clsPrefix: {
      type: String,
      required: !0
    },
    showArrow: {
      type: Boolean,
      default: void 0
    },
    showClear: {
      type: Boolean,
      default: void 0
    },
    loading: {
      type: Boolean,
      default: !1
    },
    onClear: Function
  },
  setup(e, {
    slots: l
  }) {
    return () => {
      const {
        clsPrefix: o
      } = e;
      return r(n, {
        clsPrefix: o,
        class: `${o}-base-suffix`,
        strokeWidth: 24,
        scale: 0.85,
        show: e.loading
      }, {
        default: () => e.showArrow ? r(t, {
          clsPrefix: o,
          show: e.showClear,
          onClear: e.onClear
        }, {
          placeholder: () => r(f, {
            clsPrefix: o,
            class: `${o}-base-suffix__arrow`
          }, {
            default: () => s(l.default, () => [r(i, null)])
          })
        }) : null
      });
    };
  }
});
export {
  x as default
};
